'use strict';

import {module} from '../app';

module.service('eventsMgr', ['$rootScope', function($rootScope) {
  return {
    on: function(name, cb) {
      return { unsubscribe: $rootScope.$on(name, cb) };
    },

    send: function(name, obj) {
      $rootScope.$broadcast(name, obj);
    }
  };
}]);



// WEBPACK FOOTER //
// ./src/scripts/services/eventsMgr.js